import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/styles/base.css";
import { initTransport } from "@/api/transport";
import { applyStoredTheme } from "@/app/theme";
import { App } from "./App";

applyStoredTheme();

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

// Mock mode (VITE_MOCK=1) swaps in the in-memory API before the first request.
void initTransport().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
